import { render, staticRenderFns } from "./PriorityListItem.vue?vue&type=template&id=2a5dd1d8&"
import script from "./PriorityListItem.vue?vue&type=script&lang=ts&"
export * from "./PriorityListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PriorityListItem.vue?vue&type=style&index=0&id=2a5dd1d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports